export class ModuleModel {
  constructor(
    public id: number = null,
    public category: string = null,
    public labelFr: string = null,
    public labelEn: string = null,
    public labelDe: string = null,
    public checked = false,
    public action: string = null
  ) {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
